"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decimeter = exports.Mile = exports.Inch = exports.Yard = exports.Foot = exports.Millimeter = exports.CentiMeter = exports.Kilometer = void 0;
var uom_1 = require("uom");
/** Equivalent to <code>KILO(METER)</code>. */
exports.Kilometer = uom_1.UnitPrefix.Kilo("Kilometer", uom_1.BaseUnits.Meter);
/** Equivalent to <code>CENTI(METRE)</code>. */
exports.CentiMeter = uom_1.UnitPrefix.Centi("CentiMeter", uom_1.BaseUnits.Meter);
/** Equivalent to <code>MILLI(METRE)</code>. */
exports.Millimeter = uom_1.UnitPrefix.Milli("Millimeter", uom_1.BaseUnits.Meter);
// Length
exports.Foot = uom_1.Unit.timesNumber("Foot", 0.3048, uom_1.BaseUnits.Meter);
exports.Yard = uom_1.Unit.timesNumber("Yard", 3.0, exports.Foot);
exports.Inch = uom_1.Unit.divideNumber("Inch", 12.0, exports.Foot);
exports.Mile = uom_1.Unit.timesNumber("Mile", 5280.0, exports.Foot);
exports.Decimeter = uom_1.UnitPrefix.Deci("Decimeter", uom_1.BaseUnits.Meter);
//# sourceMappingURL=length.js.map